import { useEffect, useRef, useState } from 'react';
import { obtieneFechaUltProceso, obtieneGeofencesTraccar, obtieneUbicaciones } from '../../services/Logistica/LogisticaTraccarService';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Chart as ChartJS } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
//import { datosDatatable, datosGrafico } from './dataejemplo';

export const useInfoGeofences = () =>{
  const [lstDatosTable, setLstDatosTable] = useState([]);
    const [cargaTable, setCargaTable] = useState(false);
    const [labelsGraf, setLabelsGraf] = useState([]);
    const [dataGraf, setDataGraf] = useState([]);

    const [ubicacionSel, setUbicacionSel] = useState();
    const [lstUbicacion, setLstUbicacion] = useState([]);
    const [cargaUbicacion, setCargaUbicacion] = useState(false);
    const [ultimaFecha, setUltimaFecha] = useState('');
    const dt = useRef(null);

    ChartJS.register(ChartDataLabels);

    // filtros
    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        booking: { value: null, matchMode: 'contains' },
        contenedor: { value: null, matchMode: 'contains' },
        ubicacionCodigo: { value: null, matchMode: 'contains' },
        ubicacionNombre: { value: null, matchMode: 'contains' },
        dispositivoCodigo: { value: null, matchMode: 'contains' },
        dispositivoNombre: { value: null, matchMode: 'contains' },
        estadia: { value: null, matchMode: 'equals' }
    });

    // Estado para los valores visuales de los filtros
    const [valoresFiltros, setValoresFiltros] = useState({
        booking: '',
        contenedor: '',
        ubicacionCodigo: '',
        ubicacionNombre: '',
        dispositivoCodigo: '',
        dispositivoNombre: '',
        estadia: '',
        global: ''
    });
    // Función para limpiar todos los filtros
    const limpiarFiltros = () => {
        setValoresFiltros({
            booking: '',
            contenedor: '',
            ubicacionCodigo: '',
            ubicacionNombre: '',
            dispositivoCodigo: '',
            dispositivoNombre: '',
            estadia: '',
            global: ''
        });

        setFiltros({
            global: { value: null, matchMode: 'contains' },
            booking: { value: null, matchMode: 'contains' },
            contenedor: { value: null, matchMode: 'contains' },
            ubicacionCodigo: { value: null, matchMode: 'contains' },
            ubicacionNombre: { value: null, matchMode: 'contains' },
            dispositivoCodigo: { value: null, matchMode: 'contains' },
            dispositivoNombre: { value: null, matchMode: 'contains' },
            estadia: { value: null, matchMode: 'equals' }
        });
    };

    // Filtro para texto
    const textoFilterTemplate = (options, field) => {
        return (
            <InputText
                value={valoresFiltros[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtros };
                        newFilters[field].value = nuevoValor;
                        setFiltros(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // Filtro para estadia
    const cantidadFilterTemplate = (options) => {
        return (
            <InputText
                type="number"
                value={valoresFiltros.estadia}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setValoresFiltros((prev) => ({ ...prev, estadia: nuevoValor }));

                    // Actualizamos el filtro real
                    const valorNumerico = nuevoValor ? parseInt(nuevoValor) : null;
                    setTimeout(() => {
                        const newFilters = { ...filtros };
                        newFilters.estadia.value = valorNumerico;
                        setFiltros(newFilters);
                        options.filterApplyCallback(valorNumerico);
                    }, 10);
                }}
                placeholder="Filtrar por estadia"
                className="w-full"
            />
        );
    };

    useEffect(() => {
        const cargarUbicas = async () => {
            try {
                setCargaUbicacion(true);
                const response = await obtieneUbicaciones();
                setLstUbicacion(response);
            } catch (error) {
                console.error('No se puede obtener Ubicaciones');
            } finally {
                setCargaUbicacion(false);
            }
        };
        cargarUbicas();
    }, []);

    useEffect(() => {
        const getUltimoProceso = async () => {
            try {
                const data = await obtieneFechaUltProceso();
                //console.log('WWj:', data)
                setUltimaFecha(data);
            } catch (error) {
                console.error('Error al obtener Ultima Fecha Proceso');
            }
        };
        getUltimoProceso();
    }, [dataGraf]);

    // Datos para el gráfico
    const chartData = {
        labels: labelsGraf,
        datasets: [
            {
                label: 'Cantidad de Dispositivos',
                backgroundColor: ['rgba(255, 159, 64, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(153, 102, 255, 0.2)', 'rgba(80, 63, 114, 0.2)', 'rgba(21, 54, 35, 0.2)'],
                borderColor: ['rgb(255, 159, 64)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)', 'rgb(75, 192, 192)', 'rgb(153, 102, 255)'],
                borderWidth: 1,
                data: dataGraf
            }
        ]
    };
    // Opciones de configuración (título, escalas, etc.)
    const chartOptions = {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: 'Días de permanencia de Dispositivos',
                padding: {
                    bottom: 30
                }
            },
            datalabels: {
                display: true,
                anchor: 'end',
                align: 'top',
                formatter: (value) => {
                    return 'Cantidad: ' + value;
                },
                color: '#495057'
            },
            legend: {
                display: true,
                position: 'bottom'
            }
        },
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 11
                    }
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    font: {
                        size: 11
                    }
                }
            }
        }
    };

    const handleGenerar = async () => {
        if (ubicacionSel) {
            try {
                setCargaTable(true);

                const response = await obtieneGeofencesTraccar(ubicacionSel.codigo);
                //console.log('XZZ0:', response);
                setLstDatosTable(response.dataParaTable);
                const dataGrafico = response.dataParaGrafico;
                /*setLstDatosTable(datosDatatable);
                const dataGrafico = datosGrafico;*/
                const labels = dataGrafico.map((item) => item.rango);
                const data = dataGrafico.map((item) => item.conteo);
                setLabelsGraf(labels);
                setDataGraf(data);
            } catch (error) {
                console.error('Error al obtener Geofences');
            } finally {
                setCargaTable(false);
            }
        }
    };

    const exportExcelII = () => {
        const data = dt.current.props.value;
        //const columnasAExportar = ['nombre', 'fecha', 'nacion'];
        const columnasAExportar = ['booking', 'contenedor', 'ubicacionCodigo', 'ubicacionNombre', 'dispositivoCodigo', 'dispositivoNombre', 'fechaInLit', 'fechaSaLit', 'estadia'];
        const columnasNombre = ['Booking', 'Contenedor', 'Codigo Ubi.', 'Nombre Ubi.', 'Codigo disp.', 'Nombre disp.', 'Fecha Ingreso', 'Fecha Salida', 'Estadia días'];
        const header = columnasNombre.join(',');
        const body = data.map((item) => {
            // Mapea sobre las columnas que quieres y obtén solo esos valores
            const fila = columnasAExportar.map((columna) => item[columna]);
            //return fila.join(';');
            return fila.join(',');
        });
        const content = [header, ...body].join('\n');
        const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'datos_exportados.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const header = (
        <div className="formgrid grid p-fluid mb-3 align-items-center">
            <div className="field col-12 md:col-8">
                <span>{lstDatosTable.length !== 0 && 'Total Dispositivos: ' + lstDatosTable.length}</span>
            </div>
            <div className="field col-12 md:col-4 flex justify-content-end gap-2">
                <Button type="button" icon="pi pi-filter-slash" label="limpiar filtros" severity="success" onClick={limpiarFiltros} data-pr-tooltip="Limpiar Filtros" size="small" />
                <Button type="button" icon="pi pi-file-excel" label="exportar excel" severity="success" onClick={() => exportCSV(false)} data-pr-tooltip="Exportar a XLS" size="small" />
            </div>
        </div>
    );

  return {cargaUbicacion, ubicacionSel, setUbicacionSel, ultimaFecha, handleGenerar, 
    cargaTable, chartData, chartOptions, lstUbicacion, dt, lstDatosTable, header, 
    textoFilterTemplate, cantidadFilterTemplate, filtros, exportExcelII}

}